import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import styles from './StepsFooter.module.sass';
import BREAKPOINTS from '../../constants/breakpoints';
import ClickableDiv from '../../../ui_kit/clickable_div/ClickableDiv';

function StepsFooter(props) {
  const { currentStep, goToStep, steps } = props;

  if (steps.length === 0) {
    return null;
  }

  const onStepClicked = (step) => {
    if (step >= currentStep) { return; }

    goToStep(step);
  };

  return (
    <MediaQuery query={`(min-width: ${BREAKPOINTS.DESKTOP_WIDTH_BREAKPOINT}px)`}>
      <div className={styles.footer}>
        {steps.map((step, index) => (
          <ClickableDiv
            key={step}
            className={`${styles.step} ${currentStep === index + 1 && styles.active}`}
            onClick={() => { onStepClicked(index + 1); }}
          >
            {step}
          </ClickableDiv>
        ))}
      </div>
    </MediaQuery>
  );
}

StepsFooter.propTypes = {
  currentStep: PropTypes.number.isRequired,
  goToStep: PropTypes.func.isRequired,
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default StepsFooter;
